export default (id, t) => {
  switch (id) {
    case 10001:
      return {
        title: t('common:sub-description-title-1'),
        description: t('common:sub-description-detail-1')
      }
    case 10002:
      return {
        title: t('common:sub-description-title-2'),
        description: t('common:sub-description-detail-2')
      }
    case 10003:
      return {
        title: t('common:sub-description-title-3'),
        description: t('common:sub-description-detail-3')
      }
    case 10004:
      return {
        title: t('common:sub-description-title-4'),
        description: t('common:sub-description-detail-4')
      }
    case 10005:
      return {
        title: t('common:sub-description-title-5'),
        description: t('common:sub-description-detail-5')
      }
    case 10006:
      return {
        title: t('common:sub-description-title-6'),
        description: t('common:sub-description-detail-6')
      }
    case 10007:
      return {
        title: t('common:sub-description-title-7'),
        description: t('common:sub-description-detail-7')
      }
    case 10008:
      return {
        title: t('common:sub-description-title-8'),
        description: t('common:sub-description-detail-8')
      }
    case 10010:
      return {
        title: t('common:sub-description-title-9'),
        description: t('common:sub-description-detail-9')
      }
    case 10011:
      return {
        title: t('common:sub-description-title-10'),
        description: t('common:sub-description-detail-10')
      }
    case 10012:
      return {
        title: t('common:sub-description-title-11'),
        description: t('common:sub-description-detail-11')
      }
    case 10013:
      return {
        title: t('common:sub-description-title-12'),
        description: t('common:sub-description-detail-12')
      }
    case 10014:
      return {
        title: t('common:sub-description-title-13'),
        description: t('common:sub-description-detail-13')
      }
    default:
      return {
        title: t('common:sub-description-not-found'),
        description: t('common:sub-description-not-found')
      }
  }
}



// WEBPACK FOOTER //
// ./utils/getSubscriptionDescription.js